<template>
    <v-overlay :value="dialog">
        <v-dialog
            v-model="dialog"
            persistent
            content-class="d-flex justify-center align-center"
            overlay-color="#514585"
            overlay-opacity="0.98"
        >
            <v-img
                :src="require('@/assets/img/icons/treasure-stroke.png')"
                class="dialog-icon"
                height="80"
                width="80"
                alt="pistas imagen de modal"
                />
            <v-card
                class="d-flex flex-column justify-center align-center border-radius-1"
                id="success-modal"
            >
                <div class="d-flex flex-column justify-center align-center position-relative">
                    <div class="pa-2 mx-5 mt-5">
                        <span class="text-h6 white--text font-weight-lighter">
                            {{
                                success
                                    ? $t('challenge.very_well_done')
                                    : $t('challenge.result_msg_0')
                            }}
                        </span>
                    </div>
                    <div class="px-5 mx-5">
                        <!-- <span class="white--text text-body-1">
                            {{ success ? $t('challenge.success_msg') : $t('challenge.fail_msg') }}
                        </span> -->
                        <v-row>
                            <v-col class="pa-0">
                                <v-chip
                                    label
                                    dark
                                    small
                                    color="#514585"
                                    class="text-transform-uppercase"
                                    >
                                    {{ $t('challenge.your_rewards') }}
                                </v-chip>
                            </v-col>
                        </v-row>
                        <div class="mt-3 d-flex justify-center flex-row align-center">
                            <div
                                class="position-relative text-center mx-1 d-flex justify-center align-center"
                            >
                                <div class="btn-outline d-flex">
                                    <v-img
                                        :src="require('@/assets/img/icons/xp-coin.png')"
                                        height="32"
                                        width="32"
                                        class="mr-1">
                                    </v-img>
                                    {{pointsWon}}
                                </div>
                            </div>
                            <div
                                class="position-relative text-center mx-1 d-flex justify-center align-center"
                            >

                            <div class="btn-outline d-flex">
                                <v-img
                                    :src="require('@/assets/img/icons/beecoins.png')"
                                    height="32"
                                    width="32"
                                    class="mr-1">
                                </v-img>
                                {{ coinsWon }}
                            </div>
                            </div>
                        </div>
                    </div>
                    <v-card-actions class="d-flex justify-center align-center ma-4 mt-8">
                        <v-spacer></v-spacer>
                        <v-btn
                            data-cy="challengeSuccessModal-exit-button"
                            color="white"
                            large
                            class="px-10 border-radius-1 text-transform-none font-size-16"
                            outlined
                            @click="exit">
                            {{ $t('exit') }}
                        </v-btn>
                        <v-btn
                            data-cy="challengeSuccessModal-newChallenge-button"
                            color="white"
                            large
                            elevation="0"
                            class="text--primary border-radius-1 text-transform-none font-size-16 px-5"
                            @click="newChallenge">
                            {{ $t('challenge.new_challenge') }}
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
        </v-dialog>
    </v-overlay>
</template>
<script>
/* eslint-disable global-require */
import AnalyticEventsMixin from "../../../../../mixins/analyticEvents"
import { AnalyticEventTypes } from '@/constants/AnalyticEventTypes'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        count_beecoins: { type: [String, Number], default: 0 },
        wildcard_price: { type: [String, Number], default: 0 },
        coinsWon: { type: [String, Number], default: 0 },
        pointsWon: { type: [String, Number], default: 0 },
        success: { type: Boolean, default: false },
    },
    mixins: [AnalyticEventsMixin],
    data() {
        return {
            varitaImg: require('@/assets/img/icons/beecoins-1.svg'),
        }
    },
    methods: {
        exit() {
            this.$emit('exit-challenge')
        },
        newChallenge() {
            this.$emit('new-challenge')
            this.createAnalyticEvent(AnalyticEventTypes.NewChallengeLoaded)
            this.$ga.event('pageLoaded', 'newChallenge')
            this.dialog = false
        },
    },
    computed: {
        msg_beecoins() {
            return `${this.$t('bookReading.have')} ${this.count_beecoins} ${this.$t('beecoins')}`
        },
    },
}
</script>
<style>
.bee-img {
    width: 15vh;
    text-align: left;
    top: 2.5vh;
    left: 2.5vh;
    line-height: 1.5vh;
}
.bee-img span {
    font-size: 12px !important;
    font-weight: 400;
    letter-spacing: 1px !important;
}
.bee-img img {
    height: 5vh;
}
.p-img {
    z-index: 300;
}
.p-img img {
    height: 20vh;
    z-index: 10;
}
.success-content {
    width: 35%;
    border: 20px solid #5d5286;
    border-radius: 26px;
    background: linear-gradient(146.1deg, #6d5bb0 0%, #b5a1eb 100%);
    /* height: 40vh; */
}
.items-unset {
    align-items: unset !important;
}

.bright-points {
    align-items: center;
    color: #816ad6;
}

.bright-beecoin {
    align-items: center;
    color: darkgoldenrod;
}

.form-title {
    color: white;
    font-size: 2.5vw;
}

.form-text {
    font-size: 1.2vw;
    color: white;
}

.beecoin-top-1 {
    z-index: 1;
    position: relative;
    bottom: 11vh;
    left: 5vw;
}

.beecoin-top-2 {
    transform: rotate(15deg);
    position: relative;
    bottom: 13vh;
    left: 1vw;
}

.text-beecoin {
    font-size: 1vw;
}

.button-text {
    text-transform: none;
    font-size: 1vw;
}
.bee-icon-size {
    width: 16.5vh;
}
.bee-icon-size-2 {
    width: 17.5vh;
}
.z-text {
    z-index: 10;
}
.btn-outline{
    align-items: center;
    background: #FFFFFF1A;
    border: 1px solid white;
    border-radius: 10px;
    color: white;
    display: flex;
    font-size: 1.3em;
    font-weight: bold;
    padding: .4em;
}
</style>
